<template>
  <hm-content title="新增排班">
    <div>
      <el-select
        v-model="storeOutletId"
        placeholder="选择门店"
        size="small"
        filterable
        class="mr10"
        @change="selectStore"
      >
        <el-option
          v-for="item in storeList.list"
          :key="item.value"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        :disabled="!storeOutletId"
        v-model="storeUserId"
        placeholder="选择技师"
        size="small"
        @change="selectGuider"
        filterable
      >
        <el-option
          v-for="(item, i) in staffList.list"
          :key="i"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        :label="v.name"
        :name="String(i)"
        v-for="(v, i) in guiderServiceList"
        :key="i"
      >
        <div class="flex mb10">
          <div class="color-block"></div>
          已选中
        </div>
        <div class="select-wrapper">
          <hm-time-select ref="timeSelect" @getSelectedList="getSelectedList">
          </hm-time-select>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-button size="small" type="primary" @click="save">提交</el-button>
    <!-- 该组件为了解决ctrl+左键不能取消选中 -->
    <div style="opacity: 0; position: fixed; right: -100%; top: -100%">
      <hm-time-select></hm-time-select>
    </div>
  </hm-content>
</template>

<script>
import HmTimeSelect from "@/components/HmTimeSelect";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeTab: "0",
      lastActiveTab: "0",
      activeName: "0",
      storeOutletId: "",
      storeUserId: "",
      assignedList: [],
      guiderServiceList: [],
      ruleList: [],
      eleList: []
    };
  },
  computed: mapGetters(["storeList", "staffList"]),
  created() {},
  mounted() {
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
    // 测试
    this.$store
      .dispatch("queryStaffList", {
        pageSize: 999,
        storeOutletId: 3
      })
      .then(() => {
        this.storeUserId = 10;
        this.selectGuider();
      });
  },
  methods: {
    selectStore(e) {
      this.assignedList = [];
      this.$store.commit("RESET_STAFF_LIST");
      this.storeUserId = "";
      this.$store.dispatch("queryStaffList", {
        pageSize: 999,
        storeOutletId: e
      });
    },
    selectGuider() {
      const { serverId, serverName } = this.staffList.list.find(
        v => v.id === this.storeUserId
      );
      this.serverId = "";
      this.guiderServiceList = [];
      this.assignedList = [];
      serverId.split(",").forEach((v, i) => {
        this.guiderServiceList.push({
          name: serverName.split(",")[i],
          id: v
        });
        this.ruleList.push({
          maxValue: 1,
          serverId: v,
          dateList: []
        });
      });
    },

    getSelectedList(list) {
      this.ruleList[this.activeTab].dateList = list;
    },
    handleClick(tab) {
      // 上一个索引
      this.activeTab = +tab.index;
      // this.lastActiveTab = +this.activeTab;
      // // 当前索引
      // // 将上一个已选择数据添加到ruleList
      // this.ruleList[this.lastActiveTab].dateList = this.$refs.timeSelect[
      //   this.lastActiveTab
      // ].getSelectedList();
      // // 重置selected
      this.$refs.timeSelect[this.activeTab].eleList.forEach(v => {
        v.selected = false;
      });
      this.$refs.timeSelect[this.activeTab].eleList.forEach(v => {
        this.ruleList[this.activeTab].dateList.forEach(item => {
          if (v.index === item.index) {
            setTimeout(() => {
              v.selected = true;
            }, 0);
          }
        });
      });
    },
    save() {
      // this.$store
      //   .dispatch("addScheduling", {
      //     // id: v.ruleId,
      //     dateList: this.dateList,
      //     maxValue: 1,
      //     serverId: this.serverId
      //   })
      //   .then(res => {
      //     if (res.code === "0") {
      //       this.$message({
      //         message: "操作成功！",
      //         type: "success"
      //       });
      //     }
      //   });
    }
  },
  components: { HmTimeSelect }
};
</script>

<style scoped lang="scss">
.tip {
  color: #999;
  margin: 10px 0;
  font-size: 14px;
}
.color-block {
  width: 20px;
  height: 20px;
  background: #e50163;
  opacity: 0.2;
  margin-right: 10px;
}
</style>
